<template>
    <div>
        <v-dialog @keydown.esc="closeErrorPopup"  max-width="500" persistent v-model="$store.getters.errorPopup">
            <v-card :style="colorBackground($store.getters.errorPopupProps.successStyle)">
                <v-card-title :class="$store.getters.errorPopupProps.class">
                    <h4>{{$store.getters.errorPopupProps.title}}</h4>
                    <v-spacer></v-spacer>
                    <v-icon @click="closeErrorPopup" color="white">close</v-icon>
                </v-card-title>
                <br/>
                <v-form class="mx-2">
                    <v-card-text >
                        <v-container fill-height>
                            <v-row justify="center" align="center">
                            <v-col class="pa-0 pb-2 pr-0 pl-0"  cols="1">
                                <v-icon v-if="$store.getters.errorPopupProps.icon === 'error'" color="indianRed" x-large>report_problem</v-icon>
                                <v-icon v-if="$store.getters.errorPopupProps.icon === 'success'" color="teal" x-large>verified</v-icon>
                            </v-col>
                            <v-col class="pa-0" cols="11">
                                <v-spacer/>
                                <p :style="fontStyle($store.getters.errorPopupProps.successStyle)">{{$store.getters.errorPopupProps.text}}</p>
                            </v-col>
                        </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn block class="white--text" style="text-transform: none !important;" :color="$store.getters.errorPopupProps.color" large primary @click="closeErrorPopup">Κλείσιμο</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: "ErrorPopup",
        methods: {
            closeErrorPopup() {
                this.$store.commit('setErrorPopup', false);
            },

            colorBackground(success){
                if(success)
                    return 'background-color: #B2DFDB;';
                else
                    return 'background-color: #FFFFFF;';
            },

            fontStyle(success){
                if(success)
                    return 'font-style: italic;color: #546E7A;font-weight: bold;font-size:20px;';
                else
                    return 'font-style: italic;font-size:16px;';
            },
        },
    }
</script>

<style scoped>

</style>